<button (click)="onExport()">
  <mat-icon *ngIf="!(exportInProgress$ | async)" aria-hidden="false" aria-label="Export list" i18n-aria-label>cloud_download</mat-icon>
  <mat-spinner *ngIf="exportInProgress$ | async" diameter="20"></mat-spinner>
</button>
